import { render, staticRenderFns } from "./CollarSidebar.vue?vue&type=template&id=0bd0a84f&scoped=true&"
import script from "./CollarSidebar.vue?vue&type=script&lang=js&"
export * from "./CollarSidebar.vue?vue&type=script&lang=js&"
import style0 from "./CollarSidebar.vue?vue&type=style&index=0&id=0bd0a84f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd0a84f",
  null
  
)

export default component.exports